import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { ISamAgent } from './ISamAgent';
import { ISamCompany } from './ISamCompany';
import { SamResourceService } from './samResource.service';

@Injectable()
export class CacheSamResourceService {

    private readonly cache: Map<string, Observable<[ISamAgent, ISamCompany]>> = new Map();

    constructor(
        private readonly samResource: SamResourceService,
    ) {}

    public getAgentAndCompany(agentId: number, companyId: number)
        : Observable<[ISamAgent, ISamCompany]> {
        const key: string = `${agentId}-${companyId}`;

        if (!this.cache.has(key)) {
            const response: Observable<[ISamAgent, ISamCompany]> =
                this.samResource.getAgentAndCompany(agentId, companyId)
                    .pipe(
                        shareReplay(1),
                        catchError((error: Error): Observable<never> => {
                            this.cache.delete(key);
                            return throwError(error);
                        }),
                    );

            this.cache.set(key, response);
            return response;
        }
        return this.cache.get(key);
    }
}